module.exports = __webpack_public_path__ + "static/media/ZackZ.ecb8487a.jpeg";